import { IUpdateClienteCentroCustoUseCase } from "../../../presentation/useCases/update/update_cliente_centro_custo_use_case";
import { ClienteCentroCusto } from "../../models/clienteCentroCusto";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * UpdateClienteCentroCustoUseCase
 */

export class UpdateClienteCentroCustoUseCase implements IUpdateClienteCentroCustoUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(form: ClienteCentroCusto): Promise<void> {
    await this.repository.updateClienteCentroCusto(form);

  }
}
